import React, {Component} from 'react'

class NoLabels extends Component {
    render() {
        return (
            <tr className='NoLabels'>
                <td colSpan={20}><i>No items</i></td>
            </tr>
        )
    }
}

export default NoLabels
